export default "/assets/progress.png";